import * as React from 'react';
import type { SVGProps } from 'react';
const SvgUnified = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M8 15A5 5 0 1 1 8 5a5 5 0 0 1 0 10m-6.5-5A6.5 6.5 0 0 1 10 3.813a6.5 6.5 0 1 1 0 12.373A6.5 6.5 0 0 1 1.5 10m10.656 4.998a5 5 0 0 0 0-9.996A6.49 6.49 0 0 1 14.5 10c0 2.01-.912 3.805-2.344 4.998"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgUnified;
